module.exports = require('./helpers/bundle-url').getBundleURL('5v461') + "qr-phone.422d73ed.svg";